<template>
  <div class="kd-layout-buttons">
    <div class="kd-layout-buttons__inner-wrapper">
      <kd-button
        text="Text hinzufügen"
        class="kd-layout-buttons__button"
        :no-fill="false"
        :icon="require('../assets/images/icons/text-style.svg')"
        color="#333"
        background-color="#DCDCDC"
        @click="onCreateTextLayerClick"
        type="primary"
        size="medium"
      ></kd-button>
      <kd-button
        text="Bild hinzufügen"
        class="kd-layout-buttons__button"
        :no-fill="false"
        :icon="require('../assets/images/icons/common-file-horizontal-image.svg')"
        color="#333"
        background-color="#DCDCDC"
        @click="onCreateFotoLayerClick"
        type="primary"
        size="medium"
      ></kd-button>
      <kd-button
        text="Duplizieren"
        class="kd-layout-buttons__button"
        :no-fill="false"
        :icon="require('../assets/images/icons/common-file-horizontal-image.svg')"
        color="#333"
        background-color="#DCDCDC"
        :is-deactivated="!isLayerSelected || !isLayerClonable"
        @click="onDuplicateLayerClick"
        type="primary"
        size="medium"
      ></kd-button>
      <kd-button
        text="Löschen"
        class="kd-layout-buttons__button"
        :no-fill="false"
        :icon="require('../assets/images/icons/bin-1.svg')"
        color="#333"
        background-color="#DDB6B5"
        :is-deactivated="!isLayerSelected"
        @click="onDeleteLayerClick"
        size="medium"
      ></kd-button>
    </div>
  </div>
</template>

<script>
import * as log from 'loglevel';
import KdButton from '@/components/KdButton.vue';
import { mapGetters, mapMutations } from 'vuex';

import {
  ACTIVE_LAYER_ID,
  ACTIVE_LAYER_TYPE,
} from '@/store/getter-types';

import {
  DELETE_ACTIVE_LAYER,
  DUPLICATE_ACTIVE_LAYER,
  CREATE_TEXT_LAYER,
  CREATE_FOTO_LAYER,
} from '@/store/mutation-types';

export default {
  computed: {
    ...mapGetters([
      ACTIVE_LAYER_ID,
      ACTIVE_LAYER_TYPE,
    ]),
    isLayerSelected() {
      /* eslint-disable no-unneeded-ternary */
      return this.ACTIVE_LAYER_ID ? true : false;
    },
    isLayerClonable() {
      return ['foto', 'text'].includes(this.ACTIVE_LAYER_TYPE);
    },
  },
  methods: {
    ...mapMutations([
      DELETE_ACTIVE_LAYER,
      DUPLICATE_ACTIVE_LAYER,
      CREATE_TEXT_LAYER,
      CREATE_FOTO_LAYER,
    ]),
    onCreateTextLayerClick() {
      this.CREATE_TEXT_LAYER();
    },
    onCreateFotoLayerClick() {
      this.CREATE_FOTO_LAYER();
    },
    onDeleteLayerClick() {
      this.DELETE_ACTIVE_LAYER();
    },
    onDuplicateLayerClick() {
      this.DUPLICATE_ACTIVE_LAYER();
    },
  },
  components: {
    KdButton,
  },
};
</script>

<style lang="scss">
.kd-layout-buttons {
  height: 100%;
  width: 200px;
  position: absolute;
  top: 0;
  right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media all and (max-width: 1200px) {
    width: 162px;
  }
}

.kd-layout-buttons__inner-wrapper {}

.kd-layout-buttons__button {
  & + & {
    margin-top: 12px;
  }
}
</style>
